import { useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

type SelectableStaticListProps = {
  className?: string;
  label: string;
  items: any[];
  initialOpen?: boolean;
  isOrQueryContainer?: boolean;
};

export default function SelectableStaticList({
  className,
  label,
  items,
  initialOpen = false,
  isOrQueryContainer = false,
}: SelectableStaticListProps) {
  const [open, setOpen] = useState(initialOpen);

  return (
    <div className={`w-full ${className ? className : ''}`}>
      <div
        onClick={() => setOpen((prevState) => !prevState)}
        className="flex flex-row items-center hover:bg-gray-200 cursor-pointer p-1 -ml-2 rounded-lg"
      >
        <div className="flex flex-row items-center">
          {open ? <FaAngleUp /> : <FaAngleDown />}
        </div>
        <div className="px-2">{label}</div>
        {isOrQueryContainer && (
          <div className="text-xs bg-gray-200 text-gray-700 w-6 h-6 rounded-full flex items-center justify-center">
            or
          </div>
        )}
      </div>
      <div
        className={`pl-5 flex flex-row h-full w-full ${
          open ? 'visible' : 'hidden'
        }`}
      >
        <ul className="w-full">
          {items.length &&
            items.length > 0 &&
            items.map((item, idx) => (
              <li className="py-1 w-full overflow-none" key={idx}>
                {item}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
